import { render } from "./ReviewSummary.vue?vue&type=template&id=9ed04998&scoped=true"
import script from "./ReviewSummary.vue?vue&type=script&lang=js"
export * from "./ReviewSummary.vue?vue&type=script&lang=js"

import "./ReviewSummary.vue?vue&type=style&index=0&id=9ed04998&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed04998"]])

export default __exports__